import { Control, Controller } from "react-hook-form";

import { useLeadWorkflow } from "../../../lib/hooks/api/leads/useLeadWorkflow";
import { GroupedStageOptions } from "../../shared/stage/types";
import { processTransitions } from "../../shared/stage/utils";
import { WorfklowStageCheckboxList } from "../../shared/stage/WorfklowStageCheckboxList";
import { LeadFilters } from "../leads_table/utils";

type LeadStageCheckboxSelectProps = {
  control: Control<LeadFilters, unknown>;
};

export function LeadStageCheckboxSelect({ control }: LeadStageCheckboxSelectProps) {
  const { data } = useLeadWorkflow();

  const options: GroupedStageOptions[] = data ? processTransitions(data.transitions) : [];

  return (
    <div aria-label="Lead stage filters">
      <Controller
        name="stageIds"
        control={control}
        render={({ field }) => (
          <WorfklowStageCheckboxList
            {...field}
            stageGroups={options}
            checkedStageIds={field.value ?? []}
          />
        )}
      />
    </div>
  );
}
